import { SEOHead } from '../../components/seo/SEOHead';
import { useOrders } from '../../hooks/useOrders';
import { Spinner } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { api } from '../../lib/api';

export default function Invoices() {
  const { orders, isLoading } = useOrders();
  const paidOrders = orders.filter((o) => o.invoiceId);

  return (
    <>
      <SEOHead title="Invoices — Bharat Consultancy" description="" canonicalPath="/dashboard/invoices" />

      <h1 className="font-display text-2xl font-bold text-ink">Invoices</h1>

      <div className="mt-6 space-y-3">
        {isLoading ? (
          <Spinner className="h-6 w-6 text-seal-blue" />
        ) : paidOrders.length === 0 ? (
          <p className="text-ink/60">No invoices yet — invoices appear here once an order is paid.</p>
        ) : (
          paidOrders.map((order) => (
            <div
              key={order.id}
              className="flex items-center justify-between rounded-lg border border-line bg-white p-4"
            >
              <div>
                <p className="font-mono text-sm text-ink/50">{order.orderNumber}</p>
                <p className="font-medium text-ink">{order.service?.title ?? 'Service'}</p>
                <p className="text-sm text-ink/60">₹{order.totalAmount.toLocaleString('en-IN')}</p>
              </div>
              <a href={api.invoices.downloadUrl(order.id)} target="_blank" rel="noreferrer">
                <Button size="sm" variant="outline">
                  Download
                </Button>
              </a>
            </div>
          ))
        )}
      </div>
    </>
  );
}
